import { hasDigitalSuiteCompetitivePermission } from "app/components/SideBar/utils";
import { isLocked } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

export const getIsKeywordsLocked = () => isLocked(swSettings.components.DigitalSuiteAcquisition);
export const getIsWebsitesLocked = () => !hasDigitalSuiteCompetitivePermission();
